module.exports = __webpack_public_path__ + "images/柏纳长图_08-2.jpg?v=93705399";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan1/柏纳长图_08-2.jpg
 ** module id = 149
 ** module chunks = 1 2
 **/